import React from "react";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
export function TermOfConditionPage() {
  return (
    <>
      <div className="d-flex flex-center mb-15">
        <Link to="/auth/Registration">
          <SVG
            src={toAbsoluteUrl("/media/svg/logos/Full-Color_-RGB_Vertical.svg")}
          />
        </Link>
      </div>
      <div className="container">
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            textAlign: "center",
            background: "white",
          }}
        >
          <strong>
            <span
              style={{
                fontSize: "32px",
                fontFamily: "Poppins",
                color: "#3F4254",
              }}
            >
              Terms and Conditions
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            eMPower Technologies, LLC TERMS &amp; CONDITIONS
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            The following terms and conditions (“Terms &amp; Conditions”) govern
            your use of the eMPower Technologies, LLC (“EmpowerDL”) service
            which may consist of web sites, mobile applications, installed
            applications, and service offerings (“Service”). By accessing,
            viewing, or using the content, material, or services available on or
            through this Service, you (“You”) indicate that you have read and
            understand the Terms &amp; Conditions herein and as they may change
            from time to time, and that you agree to them and intend to be
            legally bound by them. “You” refers to the individual using the
            EMPOWERDL Service and if You use the Service on behalf of a
            corporation, LLC, partnership, or other business entity, then You
            shall include that business entity and any individuals associated
            therewith using our Service. Once You accept these Terms &amp;
            Conditions, You hereby acknowledge and agree that at anytime, and at
            its sole discretion, EMPOWERDL may modify the Terms &amp; Conditions
            by posting the modified Terms &amp; Conditions on the Service,
            accessible via a link entitled EMPOWERDL Terms &amp; Conditions
            associated with this agreement and/or Site or any successor site
            explicitly designated. If You do not agree to these Terms &amp;
            Conditions, you are not granted permission to use this Service.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol style={{ marginBottom: "0in", listStyleType: "decimal" }}>
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                APPROPRIATE USE.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "1.0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            You acknowledge that our service is a neutral venue where customers
            may meet; as such we have no control over the quality, safety, or
            legal aspects of the transactions that may take place. You certify:
          </span>
        </p>
        <ol style={{ listStyleType: "decimal" }}>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              For EMPOWERDL freight match services:
            </span>
            <ol style={{ listStyleType: "decimal" }}>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  You are a bona fide shipper, freight broker, 3PL, freight
                  forwarder, intermodal or rail company or motor carrier of a
                  legal age to operate and to enter into an agreement of this
                  nature.
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  You shall maintain appropriate authority and will cease
                  immediately to use the EMPOWERDL service if for any reason You
                  no longer maintain such authority.
                </span>
                <ol style={{ listStyleType: "decimal" }}>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not represent yourselves as operating under the
                      authority of any company without express permission from
                      such company.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not attempt to broker freight without proper
                      legal authority.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not enter into any transaction to transport
                      freight without the appropriate carrier authority. You
                      must be authorized as an interstate carrier to use
                      EMPOWERDL Service(s) in any way that involves interstate
                      transport. If you are an intrastate carrier only, you are
                      strictly prohibited from the use of EMPOWERDL Service(s)
                      other than for intrastate purposes.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not enter into any transaction to transport
                      freight without the appropriate level of insurance
                      coverage or bond.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not enter into a transaction to transport freight
                      outside the geographic bounds of your carrier authority.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not enter into a transaction to transport
                      commodities You are not authorized to transport.
                    </span>
                  </li>
                  <li>
                    <span
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10.0pt",
                        color: "#3F4254",
                      }}
                    >
                      You will not enter into any transaction to transport
                      freight on equipment that fails to meet any applicable
                      Federal or State regulations.
                    </span>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              That your use of the EMPOWERDL Service is solely for your
              commercial purposes related to your movement of freight or other
              services offered by EMPOWERDL on the Service and that You shall
              not reproduce, republish, resell, or distribute such information
              in any format, in whole or in part, for sale or commercial use by
              third parties.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              Your access or use of the Service is not for the purpose of
              competing with EMPOWERDL with respect to the services offered on
              the Service. You agree any violation shall create irreparable
              harm.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              That without prior written permission of EMPOWERDL, You will not
              allow non-registered users access to the EMPOWERDL Service and
              will never provide your password to any non-registered user, nor
              will You share any information from the Service with any
              non-authorized users. It is a violation of these Terms &amp;
              Conditions to share your login.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              You shall not resell or assign your rights or obligations under
              these Terms &amp; Conditions.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              You agree that any violation of the above warranties may result in
              (1) immediate termination of your registration and access to the
              Service, (2) enforcement by EMPOWERDL availing itself of any other
              legal remedy under state and/or federal law. If a legal remedy is
              sought by EMPOWERDL, You shall be responsible for legal costs,
              including without limitation, reasonable attorney fees.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              You shall conduct your business in an ethical manner and shall not
              engage in any illegal, deceptive, misleading or fraudulent
              practice.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              Use of any import/export capability to transfer EMPOWERDL
              information from your computer system shall be restricted to one
              or more identified computers located at the address(es) noted on
              your service agreement, and shall not be distributed to any other
              location(s). Unless otherwise stated, all information downloaded
              or exported from EMPOWERDL services is intended for use by You or
              the employee performing the download and shall not be distributed
              to any other users or locations.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              All seats provided under your office subscription are for use by
              your employees or agents located at the physical address listed on
              your subscription agreement. If desired, your employees may
              download a second copy of the application on a home computer for
              temporary or occasional use for company business. Your
              subscription does not cover your employees or agents that are
              employed at a different location from the one listed on your
              subscription agreement. A separate subscription is required for
              each business location used by your agents and employees.
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              Job aggregators are not allowed to post jobs on the EMPOWERDL
              Service and You agree such access may be terminated at any time.
            </span>
          </li>
        </ol>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "decimal",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                EMPOWERDL DISCLAIMER.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL presents information in many ways; most often on our
            websites; always as a service to You. Our goal is to provide the
            most accurate information available in our complex and constantly
            changing transportation marketplace. While we endeavor to be as
            accurate and timely as possible, we make no warranty or guarantee
            concerning accuracy, reliability, completeness, or suitability, and
            provide all information AS IS. Use of our Service is at your own
            risk. EMPOWERDL does not make safety determinations; we report
            safety data using government data including, but not limited to
            FMCSA records. EMPOWERDL endeavors to keep this information as
            updated as possible, however, you must make your own determination
            as to safety, authority and/or business practices. EMPOWERDL
            provides a venue for brokers, carriers and EmpowerDL to meet in
            order to offer sell and buy services. EMPOWERDL is not involved in
            the actual transaction between buyer and seller. While we may help
            facilitate, we have no control over and do not guarantee safety or
            legality. It is your sole responsibility, as a user of the Service,
            to check the credentials, including but not limited to the
            safety/authority record, of any party introduced to You by our
            service and ascertain that such party will meet your transportation
            needs.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                CHANGE TO TERMS &amp; CONDITIONS/SERVICE &amp; DISCONTINUANCE.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL may, from time to time, at our sole discretion, make
            changes to certain of the Terms &amp; Conditions. Notification of
            any changes will be highlighted on the EMPOWERDL Service associated
            with this agreement or Site, accessible via a link entitled
            EMPOWERDL Terms &amp; Conditions, in advance of any such change.
            Your continued use of the Service after any changes shall constitute
            your agreement. EMPOWERDL reserves the right (1) to modify,
            discontinue or suspend any aspect of our Service or site at anytime,
            and (2) to impose limitations/restriction or restrict access to our
            Service without notice or liability.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                CONFIDENTIALITY/NON-DISCLOSURE.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL may disclose to You, or You may otherwise learn of or
            discover, our documents, business practices, object code, source
            code, management styles, day-to-day business operations,
            capabilities, systems, current and future strategies, marketing
            information, financial information, software technologies,
            processes, procedures, methods and applications, or other aspects of
            our business (“Our Information”). You hereby agree and acknowledge
            that any and all of Our Information is confidential and shall be our
            sole and exclusive intellectual property and proprietary
            information. You agree to use Our Information only for the specific
            purposes as allowed by these Terms &amp; Conditions. Any disclosure
            of Our Information to a third party, specifically including a direct
            competitor, is strictly prohibited and will be vigorously challenged
            in a court of law. All obligations contained herein shall survive
            the termination of this agreement. Furthermore, You acknowledge that
            Our Information is proprietary, confidential and extremely valuable
            to us, and that we would be materially damaged by your disclosure of
            Our Information. You acknowledge and agree that monetary damages
            provide an insufficient remedy for the breach of this
            confidentiality obligation, and that we shall be entitled to
            injunctive relief.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                PROPRIETARY RIGHTS.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Information provided by EMPOWERDL or its third party information
            providers is protected by federal copyright law, and is proprietary
            to EMPOWERDL and/or its third party information providers.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Copyright.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            &nbsp;The protected information found on the EMPOWERDL Service
            includes, but is not limited to, the design, layout, look,
            appearance and graphics. Reproduction is prohibited unless
            permission is granted in writing by EMPOWERDL. EMPOWERDL owns,
            solely and exclusively, all rights, title and interest in and to the
            EMPOWERDL Service, all the content (including, for example, audio,
            photographs, illustrations, graphics, pictures, drawings, sketches,
            other visuals, video, copy, recordings, software, artwork, images,
            text forms, etc.), code, data and materials thereon, the look and
            feel, design and organization of the EMPOWERDL Service, and the
            compilation of the content, code, data and materials on such
            Service, including but not limited to any copyrights, trademark
            rights, patent rights, database rights, moral rights, and other
            intellectual property and proprietary rights therein. Your use of
            the EMPOWERDL Service does not grant to You ownership of any
            content, code, data or materials You may access on these Services.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Trademarks.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            &nbsp;All trademarks, logos, service marks and trade names displayed
            on EMPOWERDL’s Service are registered to EMPOWERDL Solutions, LLC
            and may not be used unless authorized by EMPOWERDL. Those that are
            not the property of, or licensed to EMPOWERDL Solutions, LLC, are
            acknowledged on the Service. Nothing contained on any EMPOWERDL
            Service should be construed as granting, by implication, any license
            or right to use any trademark without our written permission or that
            of the third party rights holder. Your misuse of any trademark is
            strictly prohibited. If You would like to license the use of any of
            our trademarks or have questions regarding trademarks, please&nbsp;
          </span>
          <a href="https://empowerdatalogistics.com/pages/contact-us.html">
            <span
              style={{
                fontSize: "13px",
                fontFamily: "Poppins",
                color: "#6993FF",
              }}
            >
              contact us
            </span>
          </a>
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            .
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                YOUR ACCOUNT.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            To access our Service, You must register. You agree to provide true,
            accurate and complete information as prompted by the registration
            form and all forms You access in our site or receive directly from a
            EMPOWERDL representative, and You agree to update this information
            to maintain its truthfulness, accuracy, and completeness. &nbsp;By
            subscribing to any EMPOWERDL Service, You authorize EMPOWERDL to
            include data about You in the EMPOWERDL Directory. This includes
            publicly available data about your company, such as your DOT profile
            information, as well as data You have provided EMPOWERDL about your
            company and operations. All EMPOWERDL Directory information may be
            viewed by active EMPOWERDL subscribers.
          </span>
        </p>
        <ol style={{ listStyleType: "undefined", marginLeft: "0in" }}>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "13.5pt",
                color: "#3F4254",
              }}
            >
              STANDARD ACCESORIAL CHARGES
            </span>
            <ol style={{ listStyleType: "decimal" }}>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  If the carrier meets the appointment time, then these charges
                  apply. &nbsp;If the carrier does not meet the appointment time
                  both at loading and unloading then any additional charges
                  related to driver standby will not apply.
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  Free time/standby is set at 2 hours for loading and 2 hours at
                  unloading.
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  Any additional charges not defined in the shipment at the time
                  of acceptance will need to be approved by shipper prior to
                  invoice and payment through EmpowerDL if quick pay is elected.
                </span>
              </li>
              <li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "10.0pt",
                    color: "#3F4254",
                  }}
                >
                  If Quick pay is elected by the carrier at time of delivery and
                  POD is uploaded to the TaaP application then any additional
                  charges related to the shipment then need to be dealt directly
                  between the shipper and the carrier or broker.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "13.5pt",
                color: "#3F4254",
              }}
            >
              PAYMENT.
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Payments are between shipper and carrier or forwarder directly.
            &nbsp;EmpowerDL is not responsible for any payments and or
            collections. &nbsp;Empower as part of their service and application
            will generate the invoice to the shipper on behalf of the carrier.
          </span>
        </p>
        <ol style={{ listStyleType: "decimal", marginLeft: "1in" }}>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              Standard payment terms are set at net 30 days from the time the
              Proof of Delivery (POD) is received inside of the TaaP
              application. &nbsp; The receipt of the POD triggers the invoice to
              the shipper on behalf of the carrier and sets the payment terms.
              &nbsp; EmpowerDL is not involved in either payment or collection
              of invoices and all transactions are explicitly between shipper
              and carrier or broker.&nbsp;
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              If quick pay is elected at the time of delivery inside of the TaaP
              application then 3<sup>rd</sup> party financing is available
              through the EmpowerDL vendor network. &nbsp;“Quick pay” financing
              terms if elected allow for the carrier to receive payment from a 3
              <sup>rd</sup> party finance company within 72 hours of receipt of
              POD inside of the TaaP application at a 5% discount against the
              total invoice amount. &nbsp;&nbsp;
            </span>
          </li>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "10.0pt",
                color: "#3F4254",
              }}
            >
              In the event additional charges are created at the fault of the
              shipper or receiving party related to the shipment then these
              additional charges need to be entered into the shipment and
              confirmed by shipper prior to modification of invoice and Quick
              pay payment. If these charges are not entered and the carrier
              elects Quick Pay then all additional charges are waived by the
              carrier and there is no recourse for additional billing or
              collection through EmpowerDL and/or its affiliates and vendors.
            </span>
          </li>
        </ol>
        <ol style={{ listStyleType: "undefined", marginLeft: "0in" }}>
          <li>
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "13.5pt",
                color: "#3F4254",
              }}
            >
              EXPORT RESTRICTIONS &amp; COMPLIANCE WITH LAWS
            </span>
          </li>
        </ol>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            This Service may refer to some services or programs that are not
            available worldwide without specifically identifying that the offers
            are geographically limited. Our reference to such services or
            programs does not imply that EMPOWERDL intends to offer such
            services or programs in all countries or locations. You may not
            access, download, or use the Service or any material provided on our
            site in violation of U.S. export laws or regulations. You and
            EMPOWERDL agree to comply fully with all applicable laws, rules, or
            regulations, domestic or foreign, including but not limited to the
            laws and regulations concerning import and export of goods, the
            Foreign Corrupt Practices Act and other laws prohibiting bribery,
            non-discrimination, forced or involuntary labor, and equal
            opportunity in employment.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                OTHER SITES.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            This Service may, from time to time, contain links to other Internet
            websites for the convenience of users in locating information,
            products, or services that may be of interest. These sites and any
            other sites operated or maintained by third parties are operated or
            maintained by organizations over which EMPOWERDL exercises no
            control, and EMPOWERDL expressly disclaims any and all
            responsibility for the content, information, links, and other items,
            the accuracy and completeness of the information, and the quality of
            products or services made available or advertised on these
            third-party sites. EMPOWERDL does not control, endorse, promote, or
            have any affiliation with any other website unless expressly stated
            herein.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                MOBILE SERVICES.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            This Service is available to You via your mobile phone or other
            mobile device via its TaaP<strong>©</strong> application and
            interface which if You have downloaded an the application or
            subscribed, including the ability to use your mobile device to
            receive and reply to messages from EMPOWERDL and access certain
            other features (collectively, the “Mobile Services”). Your mobile
            carrier’s normal messaging, data, and other rates and fees may apply
            to your use of the Mobile Services. You acknowledge that use of
            Mobile Services, including location information, is subject to
            network capabilities, environmental conditions such as structures,
            buildings, weather, geography, landscape, and topography, available
            data, atmospheric conditions and other factors. Use may be limited
            to mobile devices located in the United States. In addition,
            downloading, installing, or using certain Mobile Services may be
            prohibited or restricted by your mobile carrier, and not all Mobile
            Services may work with all carriers or devices. Therefore, You are
            responsible for checking with your mobile carrier to determine if
            the Mobile Services are available for your mobile devices, what
            restrictions, if any, may be applicable to your use of the Mobile
            Services and how much they will cost You. By using the Mobile
            Services, You agree that EMPOWERDL may communicate with You by SMS,
            MMS or other electronic means to your mobile device and that certain
            information about your usage of the Mobile Services may be
            communicated to EMPOWERDL. In the event You change or deactivate
            your mobile telephone number, You agree to promptly update your
            mobile subscription account information with us to ensure that the
            messages EMPOWERDL intends to send to You are not sent to another
            entity who acquires such mobile telephone number. Due to coverage
            limitations, EMPOWERDL location information or data received through
            Mobile Services should not be used for or relied on for emergency
            location or safety purposes. NOTHING CONTAINED IN THESE TERMS AND
            CONDITIONS WILL CONSTITUTE OR BE CONSTRUED AS ANY REPRESENTATION OR
            WARRANTY BY EMPOWERDL THAT THE MOBILE SERVICES, INCLUDING WITHOUT
            LIMITATION, LOCATION INFORMATION (A) WILL BE AVAILABLE,
            UNINTERRUPTED, TIMELY OR ERROR-FREE; (B) WILL MEET YOUR
            REQUIREMENTS; OR (C) WILL INCLUDE DATA THAT IS ACCURATE, COMPLETE OR
            RELIABLE.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                INTERACTIONS WITH THE SERVICE.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            By interacting with the Service, transmitting any &nbsp;information,
            material, suggestions, or other content (collectively, “User
            Content”) to EMPOWERDL, You automatically grant EMPOWERDL the
            royalty-free, perpetual, irrevocable, non-exclusive right and
            license to use, reproduce, modify, adapt, publish, translate, create
            derivative works from, distribute, redistribute, transmit, perform
            and display such User Content (in whole or part) throughout the
            universe and/or to incorporate it in other works in any form, media,
            or technology now known or later developed for the full term of any
            rights that may exist in such User Content. By interacting with the
            Service or transferring information You agree that EMPOWERDL, its
            affiliates, and assigns are licensed to use the information in a
            manner we deem reasonable in our sole and independent judgment.
            &nbsp;Further, EMPOWERDL is free to use any ideas, concepts,
            know-how, techniques, and suggestions contained in any
            communications You send to this Service for any purpose whatever,
            including, but not limited to, creating and marketing products or
            services using such information. EMPOWERDL welcomes your feedback
            and suggestions about how to improve our Service.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                SYSTEM REQUIREMENTS.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            You agree to abide by recommended system requirements, including
            amendments and upgrades thereto as published by EMPOWERDL from time
            to time, and agree that EMPOWERDL's Service shall not be installed
            or used on any computer system that does not meet minimum
            requirements.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                DRIVER SAFETY
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            You agree to assume full responsibility to drive safely, observe all
            traffic rules/laws and use your own personal best judgment while
            driving. You agree that You will not enter or change information or
            otherwise interact with the Service while driving and You waive any
            claims against EMPOWERDL that may arise out of any accidents or
            damages resulting from use of the Service in violation of the
            foregoing.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                MIS-USE OF MEDIA POSTINGS, MONITORING, INDEMNIFICATION.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Although EMPOWERDL may, from time to time, monitor or review
            discussions, chats, blogs, forums, social media postings,
            transmissions, bulletin boards, and the like on the Service,
            EMPOWERDL is under no obligation to do so and assumes no
            responsibility or liability arising from the content of any such
            locations nor for any error, defamation, libel, slander, omission,
            falsehood, obscenity, pornography, profanity, danger, or inaccuracy
            contained in any information contained within such locations on the
            Service. You are prohibited from posting or transmitting any
            unlawful, threatening, libelous, defamatory, obscene, scandalous,
            inflammatory, pornographic, or profane material or any material that
            could constitute or encourage conduct that could be considered a
            criminal offense, give rise to civil liability, or otherwise violate
            any law. EMPOWERDL will fully cooperate with any law enforcement
            authorities or court order requesting or directing EMPOWERDL to
            disclose the identity of anyone posting any such information or
            materials. EMPOWERDL reserves the right to remove messages or
            material posted by You, as a user of the Service, to message boards
            or other areas, at its sole discretion. By submitting messages
            and/or materials to the Service, You agree to indemnify, defend and
            hold harmless EMPOWERDL from all damages, costs and expenses,
            including reasonable attorneys’ fees and costs arising out of all
            claims, challenges or actions, including claims for infringement,
            libel and slander, related to your submission.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                PUBLIC FORUMS.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL may, from time to time, make messaging services, chat
            services, bulletin boards, message boards, blogs, other forums and
            other such services available on or through our websites. In
            addition to any other rules or regulations that we may post in
            connection with a particular service, You agree that You shall not
            upload, post, transmit, distribute or otherwise publish through any
            website or any service or feature made available on or through our
            websites, any materials which (A) restrict or inhibit any other user
            from using and enjoying the websites or the websites’ services, (B)
            are fraudulent, unlawful, threatening, abusive, harassing, libelous,
            defamatory, obscene, vulgar, offensive, pornographic, profane,
            sexually explicit or indecent, (C) constitute or encourage conduct
            that would constitute a criminal offense, give rise to civil
            liability or otherwise violate any local, state, national or
            international law, (D) violate, plagiarize or infringe the rights of
            third parties including, without limitation, copyright, trademark,
            trade secret, confidentiality, contract, patent, rights of privacy
            or publicity or any other proprietary right, (E) contain a virus,
            spyware, or other harmful component, (F) contain embedded links,
            advertising, chain letters or pyramid schemes of any kind, or (G)
            constitute or contain false or misleading indications of origin,
            endorsement or statements of fact. You further agree not to
            impersonate any other person or entity, whether actual or
            fictitious, including anyone from EMPOWERDL. You also may not offer
            to buy or sell any product or service on or through your comments
            submitted to our forums. You alone are responsible for the content
            and consequences of any of your activities.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                PRIVACY STATEMENT.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL respects your privacy and security. EMPOWERDL’s goal is to
            provide You with a personalized Internet experience that delivers
            the information, resources, and services that are most relevant and
            helpful to You. In order to achieve this goal, EMPOWERDL may collect
            information during your visits to understand what differentiates You
            from other users. This Privacy Statement incorporated and made a
            part hereof, discloses the information gathering and dissemination
            practices of EMPOWERDL and can be viewed at&nbsp;
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <a href="http://www.empowerdatalogistics.com">
            <span style={{ fontSize: "18px", fontFamily: "Poppins" }}>
              www.empowerdatalogistics.com
            </span>
          </a>
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            .
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                DISCLAIMER OF WARRANTY AND LIABILITY.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            THIS SERVICE AND THE CONTENT ON AND MADE AVAILABLE HEREIN, AND THE
            SERVICES AND PRODUCTS OFFERED IN CONNECTION THEREWITH ARE MADE
            AVAILABLE ON AN “AS IS” BASIS ONLY. USE OF THIS SERVICE IS ENTIRELY
            AT YOUR OWN RISK. YOU ACKNOWLEDGE THAT SUCH INFORMATION AND
            MATERIALS MAY CONTAIN INACCURACIES OR ERRORS AND WE EXPRESSLY
            EXCLUDE LIABILITY FOR ANY SUCH INACCURACIES OR ERRORS TO THE FULLEST
            EXTENT PERMITTED BY LAW. EMPOWERDL MAKES NO REPRESENTATIONS OR
            WARRANTIES, AND HEREBY DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES,
            WITH RESPECT TO THIS SERVICE AND THE CONTENT ON AND MADE AVAILABLE
            THROUGH THIS SERVICE, AND THE SERVICES AND PRODUCTS OFFERED IN
            CONNECTION THEREWITH, EXPRESS AND IMPLIED, WRITTEN AND ORAL, ARISING
            FROM COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OF TRADE, AND
            OTHERWISE, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, TITLE,
            QUALITY, SYSTEMS INTEGRATION, AND NON-INFRINGEMENT. EMPOWERDL shall
            not be liable for any direct, special, indirect, incidental,
            consequential, exemplary, extra-contractual, or punitive damages of
            any kind whatsoever, including, without limitation, lost revenues or
            lost profits, which may or does result from the use of, access to,
            or inability to use this Service, the content, or the products or
            services connected therewith, regardless of legal theory, whether or
            not any party had been advised of the possibility or probability of
            such damages, and even if the remedies otherwise available fail
            their essential purpose. You acknowledge that EMPOWERDL's sole
            obligation and exclusive responsibility in the event of material and
            continuing non-conformity, defect or error in the Service shall be
            to take reasonable corrective actions upon discovery of the problem,
            and in no event shall EMPOWERDL and/or its third party information
            provider’s cumulative liability under this agreement exceed the
            total fees paid by You to EMPOWERDL during the preceding 6 months.
            EMPOWERDL's liability is limited to the fullest extent permitted by
            law.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                INDEMNIFICATION.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            You agree to defend, indemnify, and hold harmless EMPOWERDL, its
            contractors/subsidiaries/affiliated companies, and all of their
            respective directors, officers, employees, representatives,
            proprietors, partners, shareholders, servants, principals, agents,
            predecessors, successors, assigns, and attorneys from and against
            any and all suits, actions, claims, proceedings, damages,
            settlements, judgments, injuries, liabilities, losses, risks, costs,
            and expenses (including without limitation attorneys’ fees and
            litigation expenses) relating to or arising from this Service, your
            use of this Service (or any derivatives of this Service offered to
            You) or any use under your password whether or not authorized by
            You, your fraud, violation of law, or willful misconduct, and any
            breach by You of these Terms &amp; Conditions, including, but not
            limited to, your use of our site, uploading, emailing, posting,
            publishing, transmitting or submitting any content related to our
            site, or any misrepresentation, breach of warranty or certification
            made by You.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                FEES &amp; PAYMENTS/PURCHASING SERVICES.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            For Monthly Statement and ACH customers, EMPOWERDL will invoice You
            on a monthly basis for all Services, and all amounts due under such
            invoice shall be payable within twenty (20) days after the date of
            invoice.&nbsp;You shall pay all fees at the current rates in
            accordance with the current EMPOWERDL payment policies, which may be
            modified from time to time at the sole discretion of EMPOWERDL;
            customarily by written notice specified on your invoice. You are
            responsible for all taxes. Certain Services may require pre-paid
            fees and EMPOWERDL payment policy may not apply to certain other
            Services (see EMPOWERDL ONBOARD below). For credit card customers,
            You understand that your credit card may be charged for the services
            selected immediately upon receipt of your access passwords.
            Thereafter, your credit card may be charged in advance for services
            provided. Subscription price may be prorated for partial month at
            start up. If any amount due EMPOWERDL is not paid as specified, such
            amount will be subject to a finance charge, equal to 1.5% of the
            unpaid balance per month (18% per annum) or the highest amount
            allowable by law whichever is greater. EMPOWERDL shall apply all
            payments on accounts first to finance charges, and the remainder, if
            any, to the principal. EMPOWERDL reserves the right to hold You
            responsible for reasonable costs associated with collection,
            including but not limited to collection agency fees. Payment is due
            while service is active even if not used. You agree that any
            returned payment may be subject to a returned payment fee. Prices
            are subject to change upon notice. EMPOWERDL reserves the right to
            deny service to anyone at its sole discretion and to cancel service
            upon reasonable notice and/or reasonable attempts to notify.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                SECURITY DEPOSIT.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL reserves the right to require a security deposit payable
            in advance of initiating any service and retain such deposit for a
            duration determined solely by EMPOWERDL.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                DISPUTES.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            All billing disputes must be presented in writing to EMPOWERDL
            within thirty (30) days of invoice date. Direct inquiries to the
            Customer Financial Services Department, eMPower Technologies, LLC,
            10565 N 114th ST suite #116 Scottsdale, AZ 85259, or by e-mail
            to&nbsp;
          </span>
          <a href="mailto:support@empowerdl.com">
            <span
              style={{
                fontSize: "13px",
                fontFamily: "Poppins",
                color: "#6993FF",
              }}
            >
              support@empowerdl.com
            </span>
          </a>
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            .
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                TERMINATION POLICY.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            &nbsp;(As Applicable.) EMPOWERDL may with or without notice,
            terminate your access to this Service in the event You violate these
            Terms &amp; Conditions or for any reason or for convenience.
            EMPOWERDL may deny or cancel service immediately at its sole
            discretion if complaints are received. If You have a month-to-month
            contract, You may terminate your Service by going to
            support@empowerdl.com to initiate the termination. The termination
            will be effective on your next bill cycle date prior to which time
            the Service will remain available to You. For annual or multi-year
            agreements, the terms of your signed contract shall govern. Upon
            termination, immediately discontinue your use of the Service and
            destroy all materials obtained from the Service. Payment
            obligations, as agreed to by You in writing, in advance of
            termination, may survive termination. In the event You terminate a
            contract early, EMPOWERDL reserves the right to charge back multiple
            month term contract sign-up discounts received or charge an early
            termination fee as set forth in your signed contract.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                ADDITIONAL TERMS.
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Certain features, programs, products or services may contain
            separate terms and conditions, which are in addition to these
            EMPOWERDL Terms &amp; Conditions. In the event of conflicting
            provisions, the additional terms and conditions will govern.
          </span>
        </p>
        <div
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "107%",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
          }}
        >
          <ol
            style={{
              marginBottom: "0in",
              listStyleType: "undefined",
              marginLeft: "0in",
            }}
          >
            <li
              style={{
                marginTop: "0in",
                marginRight: "0in",
                marginBottom: "8.0pt",
                marginLeft: "0in",
                lineHeight: "107%",
                fontSize: "15px",
                fontFamily: '"Calibri",sans-serif',
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13.5pt",
                  color: "#3F4254",
                }}
              >
                MISCELLANEOUS PROVISIONS
              </span>
            </li>
          </ol>
        </div>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: ".5in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            . You accept that EMPOWERDL has the right to change the content or
            technical specifications of any aspect of the Service at any time,
            at its sole discretion.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            These Terms &amp; Conditions and any updates hereto represent the
            entire agreement between You and EMPOWERDL with respect to the
            subject matter hereof, supersede any and all prior and
            contemporaneous written and oral representations, understandings,
            and agreements between us, and will be governed by and construed in
            accordance with the laws of the State of Delaware. The waiver or
            failure of EMPOWERDL to exercise in any respect any right provided
            hereunder shall not be deemed a waiver of such right in the future
            or a waiver of any other rights established under these Terms &amp;
            Conditions.In the event EMPOWERDL retains legal counsel to enforce
            this agreement it shall be entitled to receive attorney’s fees,
            including fees on appeal, whether or not suit or action is
            commenced. If any provision of the Terms &amp; Conditions is found
            by a court of competent jurisdiction to be invalid, the parties
            nevertheless agree that the court should endeavor to give effect to
            the parties’ intentions as reflected in the provision, and the other
            provisions of the Terms &amp; Conditions remain in full force and
            effect.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            CONTACT US.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            If you wish to report a concern regarding these Terms &amp;
            Conditions, have any questions or need assistance, please contact
            EMPOWERDL via email at&nbsp;
          </span>
          <a href="mailto:support@empowerdl.com">
            <span
              style={{
                fontSize: "13px",
                fontFamily: "Poppins",
                color: "#6993FF",
              }}
            >
              support@empowerdl.com
            </span>
          </a>
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            , or by telephone at&nbsp;
          </span>
          <a href="tel:+14805667100" target="_blank" rel="noopener noreferrer">
            <span
              style={{
                fontSize: "13px",
                color: "#3F4254",
                textDecoration: "none",
              }}
            >
              1 (480) 566-7100
            </span>
          </a>
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            .
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            PRODUCT SPECIFIC TERMS
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL ONTIME MOBILE APPLICATION
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            In addition to the terms above, You agree that by downloading the
            EMPOWERDL OnTime application (“EMPOWERDL OnTime”), EMPOWERDL will
            license to You use of EMPOWERDL OnTime for purposes of i) accepting
            tracking on a shipment, ii) viewing shipment addresses and
            appointment times and notes about the shipment, iii) marking
            shipments at risk, and iv) exchanging messages with the load
            provider. You expressly consent to and grant EMPOWERDL the right to
            collect and disclose the location of your mobile device and other
            related information (“Location Information”) for use in connection
            with the EMPOWERDL OnTime Service. You authorize EMPOWERDL to share
            Location Information with the load provider requesting the tracking
            that you accepted. In addition, EMPOWERDL reserves the right to
            utilize Location Information gathered through EMPOWERDL OnTime, as
            part of an aggregated data set, for any reasonable commercial use;
            however, this data does not include any of your personal identifying
            information. Upon termination, EMPOWERDL retains all rights to
            previously captured data.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            RATEVIEW
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            Confidentiality of EMPOWERDL Rate Information.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            &nbsp;You will not use EMPOWERDL rate information or other
            proprietary product information to develop a competitive lane rate
            product or provide EMPOWERDL rate or product/service information to
            any company considered by EMPOWERDL to be a competitor. You shall
            not attempt to mine or replicate the rate database in order to
            compete with EMPOWERDL. You may use bulk download capability for
            internal purposes. Customer may not replicate or resell data or
            files structures received from EMPOWERDL. Confidentiality
            requirements shall survive any termination of your agreement(s).
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            CONNEXION
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            You must use a EMPOWERDL certified transportation management system
            in order to use EMPOWERDL Connexion. You agree to only use EMPOWERDL
            Connexion within the designed functionality of the certified
            transportation management system and not to reverse engineer
            EMPOWERDL Connexion, access EMPOWERDL Connexion outside of the
            certified transportation management system, or make any other use of
            or access to EMPOWERDL Connexion. It is solely your responsibility
            at all times to backup your data to be prepared to conduct your
            account without access to EMPOWERDL Connexion. EMPOWERDL DOES NOT
            REPRESENT OR WARRANT, AND SPECIFICALLY DISCLAIMS, THAT EMPOWERDL
            CONNEXION WILL BE AVAILABLE WITHOUT INTERRUPTION. However, EMPOWERDL
            shall use commercially reasonable efforts to make EMPOWERDL
            Connexion available to You during standard business hours.
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "8.0pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL ONBOARD
          </span>
        </p>
        <p
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".0001pt",
            marginLeft: "0in",
            lineHeight: "normal",
            fontSize: "15px",
            fontFamily: '"Calibri",sans-serif',
            background: "white",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontFamily: "Poppins",
              color: "#3F4254",
            }}
          >
            EMPOWERDL OnBoard is a EMPOWERDL product; co-branded by the named
            Broker and EMPOWERDL. EMPOWERDL will not sell information provided
            by carrier in the EMPOWERDL OnBoard process and will not disclose
            any personal information, i.e. tax ID numbers, to any third party;
            however EMPOWERDL reserves the right to use information provided to
            (a) send You marketing communications that we believe may be of
            interest to You in accordance with your preferences; (b) maintain,
            improve, and/or enhance the EMPOWERDL Services; and (c) protect You.
            Non-personal information provided by the carrier using EMPOWERDL
            OnBoard, such as equipment, preferred lanes and insurance agent
            information may be shared within the EMPOWERDL network. EMPOWERDL
            OnBoard carriers are authorized to use such Service at no charge.
          </span>
        </p>
      </div>
    </>
  );
}
